export default "__VITE_ASSET__DBcVDztx__"